import serumBuild from "./serumBuild";

export const serumAddress = "0x21819DA7aFA4089217C62F1D971fB1397b1f50e4";
export const serumAbi = serumBuild.abi;